// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f1dae6b0","341":"d04918e4","438":"edea1792","706":"6baacbbf","722":"ad126bb3","726":"9fe234db"}[chunkId] + ".chunk.js";
};